<section class="app-page">
  <nz-page-header [nzTitle]="titleTpl" class="site-page-header">
    <ng-template #titleTpl>
      <div class="text-2xl font-bold text-primary-focus">
        Official Places
      </div>
    </ng-template>
    >
    <nz-page-header-extra>
      <div class="flex items-center gap-4">
        <!-- View Mode Toggle -->
        <div class="flex items-center gap-2">
          <span class="text-sm font-medium text-gray-700">View:</span>
          <nz-segmented
            [nzOptions]="viewModeOptions"
            [ngModel]="viewMode()"
            (ngModelChange)="onViewModeChange($event)"
          ></nz-segmented>
        </div>

        <div class="flex space-x-2">
          <a
            (click)="showAddModal = true"
            class="w-full md:w-auto btn btn-primary"
            ><span class="fe fe-plus"></span> Add a Place</a
          >

          <button (click)="refreshPlaces()" class="btn btn-outline">
            <span
              [class.animate-spin]="
                $places.isFetching() && !$places.isInitialLoading()
              "
              class="fe fe-refresh-cw"
            ></span>
            Refresh
          </button>
        </div>
      </div>
    </nz-page-header-extra>
  </nz-page-header>

  @switch ($places.status()){ @case ('pending') {
  <buspro-resources-loading-skeletons
    [loading]="$places.isInitialLoading()"
  ></buspro-resources-loading-skeletons>
  } @case ('error') {
  <buspro-resources-query-error
    [errorMessage]="$places!.error()!.message!"
  ></buspro-resources-query-error>
  } @default {
  <section class="px-6">
    <!-- Stats Section - Hide in map view -->
    @if(viewMode() !== 'map') {
    <div>
      <div class="stats shadow w-full mb-6">
        <div class="stat">
          <div class="stat-figure text-primary">
            <span class="fe fe-map-pin text-3xl"></span>
          </div>
          <div class="stat-title">Total Places</div>
          <div class="stat-value">{{ standardPlaceStats.totalPlaces }}</div>
          <div class="stat-desc">Bus stops & Terminals</div>
        </div>

        <div class="stat">
          <div class="stat-figure text-success">
            <span class="fe fe-check-circle text-3xl"></span>
          </div>
          <div class="stat-title">Approved Places</div>
          <div class="stat-value">{{ standardPlaceStats.approvedPlaces }}</div>
          <div class="stat-desc">
            {{
              (
                (standardPlaceStats.approvedPlaces /
                  standardPlaceStats.totalPlaces) *
                100
              ).toFixed(1)
            }}% of total places
          </div>
        </div>

        <div class="stat">
          <div class="stat-figure text-secondary">
            <span class="fe fe-truck text-3xl"></span>
          </div>
          <div class="stat-title">Terminals</div>
          <div class="stat-value">{{ standardPlaceStats.terminalCount }}</div>
          <div class="stat-desc">Major stations</div>
        </div>

        <div class="stat">
          <div class="stat-figure text-accent">
            <span class="fe fe-flag text-3xl"></span>
          </div>
          <div class="stat-title">Bus Stops</div>
          <div class="stat-value">{{ standardPlaceStats.busStopCount }}</div>
          <div class="stat-desc">Pick-up points</div>
        </div>

        <div class="stat">
          <div class="stat-figure text-success">
            <span class="fe fe-check-square text-3xl"></span>
          </div>
          <div class="stat-title">Both Terminal & Bus Stop</div>
          <div class="stat-value">
            {{ standardPlaceStats.bothTerminalAndBusStopCount }}
          </div>
          <div class="stat-desc">Both Terminal & Bus Stop</div>
        </div>

        <div class="stat">
          <div class="stat-figure text-warning">
            <span class="fe fe-flag text-3xl"></span>
          </div>
          <div class="stat-title">Countries</div>
          <div class="stat-value">{{ standardPlaceStats.countriesCount }}</div>
          <div class="stat-desc">Countries covered</div>
        </div>
      </div>
    </div>
    }

    <!-- Filters row -->
    <div class="mb-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="w-full md:w-80">
        <nz-input-group [nzPrefix]="searchPrefix">
          <input
            type="text"
            nzSize="large"
            nz-input
            [formControl]="searchControl"
            placeholder="Search places..."
          />
        </nz-input-group>
        <ng-template #searchPrefix>
          <span class="fe fe-search"></span>
        </ng-template>
      </div>

      <div class="flex flex-1 items-center gap-3">
        <!-- Type filter -->
        <nz-select
          class="min-w-[12rem]"
          nzAllowClear
          nzPlaceHolder="All types"
          [formControl]="typeControl"
        >
          <nz-option [nzValue]="placeTypeEnum.Terminal" nzLabel="Terminal"></nz-option>
          <nz-option [nzValue]="placeTypeEnum.BusStop" nzLabel="Bus Stop"></nz-option>
          <nz-option [nzValue]="placeTypeEnum.TerminalBusStop" nzLabel="Terminal & Bus Stop"></nz-option>
        </nz-select>

        <!-- Status filter -->
        <nz-select
          class="min-w-[12rem]"
          nzAllowClear
          nzPlaceHolder="All statuses"
          [formControl]="statusControl"
        >
          <nz-option nzValue="Pending" nzLabel="Pending"></nz-option>
          <nz-option nzValue="Approved" nzLabel="Approved"></nz-option>
          <nz-option nzValue="Rejected" nzLabel="Rejected"></nz-option>
        </nz-select>

        <!-- Country filter -->
        <nz-select
          class="min-w-[12rem]"
          nzAllowClear
          nzPlaceHolder="Select country"
          [formControl]="countryControl"
        >
          <nz-option nzValue="Uganda" nzLabel="Uganda"></nz-option>
          <nz-option nzValue="Ghana" nzLabel="Ghana"></nz-option>
        </nz-select>

        <!-- Radius range -->
        <nz-input-group nzSize="default" class="w-40" [nzPrefix]="minRadiusPrefix">
          <input nz-input type="number" min="0" placeholder="Min radius" [formControl]="minRadiusControl" />
        </nz-input-group>
        <ng-template #minRadiusPrefix>
          <span class="fe fe-minus"></span>
        </ng-template>

        <nz-input-group nzSize="default" class="w-40" [nzPrefix]="maxRadiusPrefix">
          <input nz-input type="number" min="0" placeholder="Max radius" [formControl]="maxRadiusControl" />
        </nz-input-group>
        <ng-template #maxRadiusPrefix>
          <span class="fe fe-plus"></span>
        </ng-template>

        <!-- Sorting -->
        <nz-select class="min-w-[10rem]" [formControl]="sortByControl">
          <nz-option nzValue="name" nzLabel="Sort: Name"></nz-option>
          <nz-option nzValue="radius" nzLabel="Sort: Radius"></nz-option>
        </nz-select>
        <nz-select class="min-w-[8rem]" [formControl]="sortOrderControl">
          <nz-option nzValue="asc" nzLabel="Asc"></nz-option>
          <nz-option nzValue="desc" nzLabel="Desc"></nz-option>
        </nz-select>

        <button class="btn btn-ghost" (click)="searchControl.setValue(''); countryControl.setValue('Uganda'); typeControl.setValue(null); statusControl.setValue(null); minRadiusControl.setValue(null); maxRadiusControl.setValue(null); sortByControl.setValue('name'); sortOrderControl.setValue('asc')">
          <span class="fe fe-slash"></span>
          Clear filters
        </button>
      </div>
    </div>

    <nz-spin [nzSpinning]="$places.isInitialLoading()">
      <!-- Table View -->
      @if(viewMode() === 'table') {
      @if($places.data()?.items?.length){
      <table>
        <thead>
          <tr>
            <th>Terminal Name</th>
            <th>Place Type</th>
            <th>Geofence Radius</th>
            <th>Country</th>
            <th>Status</th>
            <th>Preview</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of $places.data()?.items" class="group">
            <td>
              <div class="flex space-x-2 items-center">
                <div>{{ data.name }}</div>
              </div>
            </td>

            <td>
              <div class="flex space-x-2 items-center">
                <nz-tag
                  *ngIf="data.type === terminalTypesEnum.Terminal"
                  nzColor="geekblue"
                  >{{ data.type }}
                </nz-tag>
                <nz-tag
                  *ngIf="data.type === terminalTypesEnum.BusStop"
                  nzColor="orange"
                  >{{ data.type }}
                </nz-tag>

                <nz-tag
                  *ngIf="data.type === terminalTypesEnum.TerminalBusStop"
                  nzColor="green"
                  >{{ data.type }}
                </nz-tag>

                <!-- Edit icon with dropdown (shown on hover) -->
                <button
                  [nzDropdownMenu]="placeTypeMenu"
                  [nzDisabled]="updatingPlaceTypeId === data.id || updatePlaceTypeMutation.isPending()"
                  class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 ml-2 p-1 rounded hover:bg-gray-100"
                  nz-button
                  nz-dropdown
                  nz-tooltip
                  nzTooltipTitle="Change place type"
                  nzTrigger="click"
                  type="button"
                >
                  <span
                    *ngIf="updatingPlaceTypeId === data.id"
                    class="fe fe-loader animate-spin text-primary"
                  ></span>
                  <span
                    *ngIf="updatingPlaceTypeId !== data.id"
                    class="fe fe-edit text-gray-500 hover:text-primary"
                  ></span>
                </button>
                <nz-dropdown-menu #placeTypeMenu="nzDropdownMenu">
                  <ul nz-menu>
                    <li
                      (click)="updatePlaceType(data, terminalTypesEnum.Terminal)"
                      [class.bg-primary]="data.type === terminalTypesEnum.Terminal"
                      [class.text-white]="data.type === terminalTypesEnum.Terminal"
                      [class.opacity-50]="data.type === terminalTypesEnum.Terminal"
                      nz-menu-item
                    >
                      <div class="flex items-center space-x-2">
                        <span class="fe fe-flag"></span>
                        <span>Terminal</span>
                        <span
                          *ngIf="data.type === terminalTypesEnum.Terminal"
                          class="fe fe-check ml-auto"
                        ></span>
                      </div>
                    </li>
                    <li
                      (click)="updatePlaceType(data, terminalTypesEnum.BusStop)"
                      [class.bg-primary]="data.type === terminalTypesEnum.BusStop"
                      [class.text-white]="data.type === terminalTypesEnum.BusStop"
                      [class.opacity-50]="data.type === terminalTypesEnum.BusStop"
                      nz-menu-item
                    >
                      <div class="flex items-center space-x-2">
                        <span class="fe fe-map-pin"></span>
                        <span>Bus Stop</span>
                        <span
                          *ngIf="data.type === terminalTypesEnum.BusStop"
                          class="fe fe-check ml-auto"
                        ></span>
                      </div>
                    </li>
                    <li
                      (click)="updatePlaceType(data, terminalTypesEnum.TerminalBusStop)"
                      [class.bg-primary]="data.type === terminalTypesEnum.TerminalBusStop"
                      [class.text-white]="data.type === terminalTypesEnum.TerminalBusStop"
                      [class.opacity-50]="data.type === terminalTypesEnum.TerminalBusStop"
                      nz-menu-item
                    >
                      <div class="flex items-center space-x-2">
                        <span class="fe fe-layers"></span>
                        <span>Terminal & Bus Stop</span>
                        <span
                          *ngIf="data.type === terminalTypesEnum.TerminalBusStop"
                          class="fe fe-check ml-auto"
                        ></span>
                      </div>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </div>
            </td>

            <td>
              <div>
                <span class="fe text-success fe-check-square"></span>
                {{ data.radius }} meters
              </div>
            </td>
            <td>
              <buspro-country-map
                [country]="data.country"
                [size]="40"
                [showLabel]="true"
              >
              </buspro-country-map>
            </td>
            <td>
              <buspro-standard-place-status
                [status]="data.status"
                [showApproveButton]="data.status === 'Pending'"
                [isApproving]="approveMutation.isPending() && approvingPlaceId === data.id"
                (approve)="approvePlace(data)"
              ></buspro-standard-place-status>
            </td>
            <td>
              <button
                (click)="
                  showPreviewLocationModal = true; selectedPlace$$.next(data)
                "
                class="btn text-center btn-circle btn-outline"
              >
                <span class="fe fe-map-pin"></span>
              </button>
            </td>
            <td>
              <button
                [nzDropdownMenu]="actions"
                nz-button
                nz-dropdown
                nzTrigger="click"
              >
                More <span class="fe fe-more-vertical"></span>
              </button>
              <nz-dropdown-menu #actions>
                <ul nz-menu>
                  <li
                    (click)="
                      showEditPlaceModal = true; selectedPlace$$.next(data)
                    "
                    nz-menu-item
                  >
                    <div class="flex space-x-2">
                      <div><span class="fe fe-edit"></span></div>
                      <div>Edit</div>
                    </div>
                  </li>

                  <li (click)="confirmDeletion(data)" nz-menu-item>
                    <div class="flex space-x-2">
                      <div><span class="fa fa-remove"></span></div>
                      <div>Delete</div>
                    </div>
                  </li>
                </ul>
              </nz-dropdown-menu>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Add pagination -->
      <div class="mt-4 flex justify-end">
        <nz-pagination
          [nzTotal]="$places.data()?.total || 0"
          [nzPageIndex]="currentPage"
          [nzPageSize]="pageSize"
          [nzShowSizeChanger]="true"
          [nzPageSizeOptions]="[10, 20, 50, 100]"
          (nzPageIndexChange)="onPageChange($event)"
          (nzPageSizeChange)="onPageSizeChange($event)"
        ></nz-pagination>
      </div>
      } @else {
      <section class="max-w-lg px-4 py-12 lg:py-20 mx-auto">
        <img
          alt="Buses"
          class="mx-auto sm:w-4/5"
          ngSrc="places.png"
          height="743"
          width="961"
        />
        <h2
          *ngIf="searchTerm; else emptyListTitle"
          class="mt-8 text-xl font-medium text-center text-gray-800"
        >
          No match found
        </h2>
        <ng-template #emptyListTitle>
          <h2 class="mt-8 text-xl font-medium text-center text-gray-800">
            Places are locations, towns and cities of your operational lines
          </h2>
        </ng-template>
        <p
          *ngIf="searchTerm; else emptyListDescription"
          class="mt-4 text-center text-gray-600"
        >
          No place name contains
          <span class="font-bold">"{{ searchTerm }}"</span>
        </p>
        <ng-template #emptyListDescription>
          <p class="mt-4 text-center text-gray-600">
            A place can be a bus stop or terminal
          </p>
        </ng-template>
        <div
          class="flex flex-col items-center justify-center mt-8 space-y-1 md:flex-row md:space-y-0 md:space-x-1"
        ></div>
      </section>
      }
      }

      <!-- Map View -->
      @if(viewMode() === 'map') {
      <div class="flex gap-4 h-[calc(100vh-280px)] min-h-[700px]">
        <!-- Map Container - Takes remaining space -->
        <div class="flex-1 relative rounded-lg overflow-hidden shadow-lg">
          <!-- Google Map -->
          <google-map
            #map
            [center]="mapCenter()"
            [zoom]="mapZoom()"
            [options]="mapOptions"
            height="100%"
            width="100%"
            (mapClick)="selectedPlaceForInfo.set(null)"
            (mapInitialized)="onMapInitialized($event)"
          >
            <!-- Markers -->
            @for (marker of mapMarkers(); track marker.id) {
              <map-marker
                [position]="marker.position"
                [title]="marker.title"
                [options]="marker.options"
                (mapClick)="onMarkerClick(marker)"
              ></map-marker>
            }

            <!-- Circles (if enabled) -->
            @if (showCircles()) {
              @for (circle of mapCircles(); track circle.id) {
                <map-circle
                  [center]="circle.center"
                  [radius]="circle.radius"
                  [options]="circle.options"
                ></map-circle>
              }
            }

            <!-- Info Window -->
            @if (selectedPlaceForInfo(); as selectedPlace) {
              <map-info-window [position]="{ lat: selectedPlace.lat, lng: selectedPlace.lng }">
                <div class="p-4 min-w-[280px]">
                  <h3 class="text-lg font-semibold mb-2">{{ selectedPlace.name }}</h3>
                  
                  <!-- Place Type -->
                  <div class="mb-2">
                    @if (selectedPlace.type === placeTypeEnum.Terminal) {
                      <nz-tag nzColor="geekblue">{{ selectedPlace.type }}</nz-tag>
                    }
                    @if (selectedPlace.type === placeTypeEnum.BusStop) {
                      <nz-tag nzColor="orange">{{ selectedPlace.type }}</nz-tag>
                    }
                    @if (selectedPlace.type === placeTypeEnum.TerminalBusStop) {
                      <nz-tag nzColor="green">{{ selectedPlace.type }}</nz-tag>
                    }
                  </div>

                  <!-- Status -->
                  <div class="mb-2 text-sm">
                    <strong>Status:</strong>
                    <span
                      [class.text-green-600]="selectedPlace.status === 'Approved'"
                      [class.text-orange-600]="selectedPlace.status === 'Pending'"
                      [class.text-red-600]="selectedPlace.status === 'Rejected'"
                    >
                      {{ selectedPlace.status }}
                    </span>
                  </div>

                  <!-- Radius -->
                  <div class="mb-2 text-sm">
                    <strong>Geofence Radius:</strong> {{ selectedPlace.radius }}m
                  </div>

                  <!-- Country -->
                  <div class="mb-3 text-sm">
                    <strong>Country:</strong> {{ selectedPlace.country }}
                  </div>

                  <!-- Actions -->
                  <div class="flex gap-2 pt-3 border-t">
                    <button
                      (click)="openPreviewModal(selectedPlace); $event.stopPropagation()"
                      class="btn btn-sm btn-primary flex-1"
                    >
                      <span class="fe fe-eye mr-1"></span>
                      Preview
                    </button>
                    <button
                      (click)="openEditModal(selectedPlace); $event.stopPropagation()"
                      class="btn btn-sm btn-success flex-1"
                    >
                      <span class="fe fe-edit mr-1"></span>
                      Edit
                    </button>
                  </div>
                </div>
              </map-info-window>
            }
          </google-map>

          <!-- Empty State for Map View -->
          @if(!$places.data()?.items?.length){
            <div class="absolute inset-0 flex items-center justify-center bg-gray-50 bg-opacity-90 z-20">
              <div class="text-center">
                <div class="text-4xl mb-4">🗺️</div>
                <h3 class="text-xl font-semibold text-gray-800 mb-2">No Places to Display</h3>
                <p class="text-gray-600">
                  @if(searchControl.value || typeControl.value || statusControl.value) {
                    Try adjusting your filters
                  } @else {
                    Add your first place to see it on the map
                  }
                </p>
              </div>
            </div>
          }
        </div>

        <!-- Sidebar - Map Info & Controls -->
        <div class="w-80 bg-white rounded-lg shadow-lg overflow-hidden flex flex-col">
          <!-- Sidebar Header -->
          <div class="p-4 border-b bg-gray-50">
            <h3 class="text-lg font-semibold text-gray-900">Map Information</h3>
            <p class="text-sm text-gray-600 mt-1">
              {{ getVisiblePlacesCount() }} place(s) visible
            </p>
          </div>

          <!-- Sidebar Content - Scrollable -->
          <div class="flex-1 overflow-y-auto p-4 space-y-6">
            <!-- Map Controls -->
            <div>
              <h4 class="text-sm font-semibold text-gray-900 mb-3">Controls</h4>
              <div class="space-y-3">
                <!-- Toggle Circles -->
                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [checked]="showCircles()"
                    (change)="toggleCircles()"
                    class="checkbox checkbox-sm"
                  />
                  <span class="text-sm text-gray-700">Show Geofence Circles</span>
                </label>

                <!-- Fit Bounds Button -->
                <button
                  (click)="fitMapBounds()"
                  class="btn btn-sm btn-primary w-full"
                >
                  <span class="fe fe-maximize-2 mr-2"></span>
                  Fit All Places
                </button>
              </div>
            </div>

            <!-- Legend -->
            <div>
              <h4 class="text-sm font-semibold text-gray-900 mb-3">Legend</h4>
              <div class="space-y-3">
                <div class="flex items-center gap-3">
                  <div class="w-5 h-5 rounded-full bg-blue-500 flex-shrink-0"></div>
                  <span class="text-sm text-gray-700">Terminal</span>
                </div>
                <div class="flex items-center gap-3">
                  <div class="w-5 h-5 rounded-full bg-orange-500 flex-shrink-0"></div>
                  <span class="text-sm text-gray-700">Bus Stop</span>
                </div>
                <div class="flex items-center gap-3">
                  <div class="w-5 h-5 rounded-full bg-green-500 flex-shrink-0"></div>
                  <span class="text-sm text-gray-700">Terminal & Bus Stop</span>
                </div>
              </div>
            </div>

            <!-- Statistics -->
            <div>
              <h4 class="text-sm font-semibold text-gray-900 mb-3">Statistics</h4>
              <div class="space-y-3">
                <!-- Total Places -->
                <div class="p-3 bg-gray-50 rounded-lg">
                  <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-600">Total Places</span>
                    <span class="text-lg font-semibold text-primary">{{ standardPlaceStats.totalPlaces }}</span>
                  </div>
                </div>

                <!-- Terminals -->
                <div class="p-3 bg-gray-50 rounded-lg">
                  <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-600">Terminals</span>
                    <span class="text-lg font-semibold text-secondary">{{ standardPlaceStats.terminalCount }}</span>
                  </div>
                </div>

                <!-- Bus Stops -->
                <div class="p-3 bg-gray-50 rounded-lg">
                  <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-600">Bus Stops</span>
                    <span class="text-lg font-semibold text-accent">{{ standardPlaceStats.busStopCount }}</span>
                  </div>
                </div>

                <!-- Both -->
                <div class="p-3 bg-gray-50 rounded-lg">
                  <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-600">Both</span>
                    <span class="text-lg font-semibold text-success">{{ standardPlaceStats.bothTerminalAndBusStopCount }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </nz-spin>
  </section>
  } }

  <buspro-admin-add-standard-place
    (hide)="showAddModal = false"
    (refresh)="refreshPlaces()"
    [defaultPlaceType]="placeTypeEnum.Terminal"
    [show]="showAddModal"
  >
  </buspro-admin-add-standard-place>

  <admin-edit-standard-place
    (hide)="showEditPlaceModal = false"
    (refresh)="refreshPlaces()"
    [place]="(selectedPlace$$ | async)!"
    [show]="showEditPlaceModal"
  >
  </admin-edit-standard-place>

  <buspro-preview-location
    (hide)="showPreviewLocationModal = false"
    [place]="(selectedPlace$$ | async)!"
    [show]="showPreviewLocationModal"
  ></buspro-preview-location>
</section>
